module.exports = __webpack_public_path__ + "static/media/image3.93e92736.png";